import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { getActors } from '../services/actorsApi'
import type { Actor } from '../services/actorsApi'

/**
 * Fetch actors (personal + organizations) for the current user.
 * Cached for 5 minutes since actors rarely change.
 * placeholderData keeps the previous actor list visible during re-fetches
 * so the account switcher never disappears unexpectedly.
 */
export function useActors(params?: { enabled?: boolean }) {
  return useQuery<Actor[]>({
    queryKey: ['actors'],
    queryFn: getActors,
    enabled: params?.enabled ?? true,
    staleTime: 5 * 60_000,
    placeholderData: keepPreviousData,
  })
}

export type { Actor }
